"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var _a, _b;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var HeadingSizeEnum;

(function (HeadingSizeEnum) {
  HeadingSizeEnum["big"] = "big";
  HeadingSizeEnum["medium"] = "medium";
  HeadingSizeEnum["small"] = "small";
})(HeadingSizeEnum = exports.HeadingSizeEnum || (exports.HeadingSizeEnum = {}));

var FontSizes = (_a = {}, _a[HeadingSizeEnum.big] = 28, _a[HeadingSizeEnum.medium] = 24, _a[HeadingSizeEnum.small] = 18, _a);
var LineHeights = (_b = {}, _b[HeadingSizeEnum.big] = 34, _b[HeadingSizeEnum.medium] = 32, _b[HeadingSizeEnum.small] = 22, _b);
exports.Heading = styled_components_1.default(function (_a) {
  var centered = _a.centered,
      size = _a.size,
      rest = __rest(_a, ["centered", "size"]);

  return react_1.default.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", "px;\n    line-height: ", "px;\n    font-weight: ", ";\n    color: ", ";\n    text-align: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", "px;\n    line-height: ", "px;\n    font-weight: ", ";\n    color: ", ";\n    text-align: ", ";\n"])), function (_a) {
  var size = _a.size;
  return size === HeadingSizeEnum.small ? 'Roboto' : 'Ubuntu';
}, function (_a) {
  var size = _a.size;
  return FontSizes[size];
}, function (_a) {
  var size = _a.size;
  return LineHeights[size];
}, function (_a) {
  var size = _a.size;
  return size === HeadingSizeEnum.small ? 'bold' : 'normal';
}, function (props) {
  return props.theme.colors.title;
}, function (_a) {
  var centered = _a.centered;
  return centered ? 'center' : 'left';
});
var templateObject_1;